import React, { Component } from 'react';
import { ButtonGroup } from '../buttonGroup/buttonGroup';
import GenderGraph from './genderGraph';
import GenderPie from './genderPie';
import GenderTable from './genderTable';
import trans from '../../translations.json';

const viewModes = {
  graph: 'graph',
  pie: 'pie',
  table: 'table',
};

class Index extends Component {
  state = {
    selectedViewMode: viewModes.graph,
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <GenderGraph
              lang={this.props.lang}
              chartTitle={trans.CasesByGender.title[this.props.lang]}
            />
          );
        case viewModes.pie:
          return <GenderPie lang={this.props.lang} />;
        case viewModes.table:
          return <GenderTable lang={this.props.lang} />;
        default:
      }
    };

    return (
      <div id="">
        <>
          <ButtonGroup
            selected={this.state.selectedViewMode}
            viewModes={viewModes}
            lang={this.props.lang}
            handleOnClick={this.onViewModeChange}
          />
          <GetRightView />
        </>
      </div>
    );
  }
}
export default Index;
